import { useLocation } from "react-router-dom";

export function useAdminPage() {
    const { pathname } = useLocation();

    return pathname.toLowerCase().includes("/admin");
}